export function tables_AutoCalculateOddRow(table?: HTMLTableElement): void {
  let tableEls: HTMLElement[] = [];

  if (typeof table !== "undefined") {
    tableEls = [table];
  } else if (document.querySelectorAll<HTMLElement>("table.table-striped--js.national-schedule-table")) {
    tableEls = [...document.querySelectorAll<HTMLElement>("table.table-striped--js.national-schedule-table")];
  }

  tableEls.forEach((tableEL) => {
    const visibleRowEls = tableEL.querySelectorAll<HTMLElement>('tbody tr:not([aria-hidden="true"])');

    visibleRowEls.forEach((rowEl, index) => {
      index % 2 == 0 ? rowEl.replaceClass("even", "odd") : rowEl.replaceClass("odd", "even");
    });
  });
}

//National table toggle
export function tables_ToggleHiddenRows(tableEl: HTMLTableElement, isUpcomming: boolean): void {
  if (tableEl) {
    const tableRowEls = tableEl.querySelectorAll<HTMLElement>("tbody tr[aria-hidden]");

    tableRowEls.forEach((tableRowEl) => {
      isUpcomming ? tableRowEl.setAttribute("aria-hidden", "true") : tableRowEl.setAttribute("aria-hidden", "false");
    });
  }
}

//State table toggle
export function tables_ToggleHiddenRowsStateTable(tableEl: HTMLTableElement, isUpcomming: boolean) {
  if (tableEl) {
    if (isUpcomming) {
      tableEl.classList.add("upcoming-table");

      tableEl.classList.remove("all-table");
    } else {
      tableEl.classList.add("all-table");

      tableEl.classList.remove("upcoming-table");
    }

    const tableRowEls = tableEl.querySelectorAll<HTMLElement>("tbody tr");
    const tableClassList = tableEl.classList;

    tableRowEls.forEach(tr => {
      const trClassList = tr.classList;
      if ((isUpcomming && !trClassList.contains("upcoming-tr")) ||
        (tableClassList.contains("residential-address-table") && !trClassList.contains("residential-address-tr")) ||
        (tableClassList.contains("business-address-table") && !trClassList.contains("business-address-tr"))
      ) {
        tr.setAttribute("aria-hidden", "true");
      } else {
        tr.setAttribute("aria-hidden", "false");
      }
    })

    tables_AutoCalculateOddRow(tableEl);
  }
}
